import * as React from "react";

const SvgProzora = ({ rackColor = "#000", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="200.66"
    viewBox="0 0 120 70"
    {...props}
  >
    <path  fill="#D7EAFF" d="M0 0h120v70H0z" />
    <path d="M0 35v35h120V0H0zm115 0v30H5V5h110z" fill={rackColor}  />
    <path
      d="M0 35v35h120V0H0zm115 0v30H5V5h110z"
      fill="none"
      stroke="black"
      strokeWidth="0.3"
    />
  </svg>
);

export default SvgProzora;
